import type { Testimonial } from '../types/landing'

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    quote: 'El Grupo Consultor Colombiano ha sido un aliado clave en la construcción de una Cámara más cercana y efectiva para las empresas.',
    author: 'Empresario de la región',
    role: 'Sector servicios',
  },
  {
    id: 't2',
    quote: 'Su experiencia y compromiso han contribuido a impulsar iniciativas que generan oportunidades reales para las MiPymes del Valle del Cauca.',
    author: 'Líder empresarial',
    role: 'Sector industrial',
  },
  {
    id: 't3',
    quote: 'Han demostrado criterio, transparencia y una visión de largo plazo. Son la voz técnica que la Junta Directiva necesita.',
    author: 'Empresaria afiliada',
    role: 'Sector comercio',
  },
  {
    id: 't4',
    quote: 'Gracias a su gestión, más empresas hoy conocen y aprovechan los programas de la Cámara de Comercio de Cali.',
    author: 'Gerente de MiPyme',
    role: 'Sector tecnología',
  },
]
